import React from 'react';
import type { LstStatus } from '../types';
import { decodeMotivoParada } from '../utils/kamishibaiStatus';

export type RotinaDisplayStatus = LstStatus | 'pendente' | 'agendado';

interface RotinaStatusBadgeProps {
  status: RotinaDisplayStatus;
  justificativa?: string | null;
  className?: string;
}

const badgeBase = 'inline-flex shrink-0 items-center rounded-full px-2.5 py-1 text-[10px] font-semibold';

/** Badge minimalista de status — extrema direita da linha (somente leitura). */
export const RotinaStatusBadge: React.FC<RotinaStatusBadgeProps> = React.memo(
  ({ status, justificativa, className = '' }) => {
    const motivo = decodeMotivoParada(justificativa);

    if (status === 'pendente' || status === 'agendado') {
      return (
        <span className={`${badgeBase} text-slate-400 dark:text-slate-500 ${className}`}>
          Agendado
        </span>
      );
    }

    if (status === 'realizado') {
      return (
        <span
          className={`${badgeBase} gap-1 bg-emerald-50 font-bold text-emerald-700 ring-1 ring-emerald-200/70 dark:bg-emerald-950/35 dark:text-emerald-300 dark:ring-emerald-800/40 ${className}`}
        >
          <span className="text-[11px] leading-none">O</span>
          Conforme
        </span>
      );
    }

    if (status === 'realizado_com_desvio') {
      return (
        <span
          className={`${badgeBase} gap-1 bg-amber-50 font-bold text-amber-800 ring-1 ring-amber-200/70 dark:bg-amber-950/35 dark:text-amber-300 dark:ring-amber-800/40 ${className}`}
        >
          <span className="text-[11px] leading-none">Δ</span>
          Desvio
        </span>
      );
    }

    if (status === 'processo_parado') {
      return (
        <span
          title={motivo ?? 'Linha parada'}
          className={`${badgeBase} bg-slate-500/25 font-bold text-slate-600 ring-1 ring-slate-400/30 dark:bg-slate-600/30 dark:text-slate-300 dark:ring-slate-500/30 ${className}`}
        >
          Linha Parada
        </span>
      );
    }

    return (
      <span
        className={`${badgeBase} gap-1 bg-red-50 font-bold text-red-700 ring-1 ring-red-200/70 dark:bg-red-950/35 dark:text-red-300 dark:ring-red-900/40 ${className}`}
      >
        <span className="text-[11px] leading-none">X</span>
        Não realizado
      </span>
    );
  },
);

RotinaStatusBadge.displayName = 'RotinaStatusBadge';
